@if (!$hideHeader()) {
  <div class="sp-page-header">

    @if ($showBack()) {
      <div class="settings-panel-header">
        <button class="settings-back-button" tabindex="-1" (click)="back.emit()">
          <i class="fa-regular fa-angle-left"></i>
        </button>
        <span class="settings-panel-title">{{ $title() }}</span>
      </div>
    } @else {
      <span class="sp-page-title">{{ $title() }}</span>
    }

    @if ($headerCommands().length) {
      <div class="sp-page-header-actions">
        @for (cmd of $headerCommands(); track cmd._id) {
          <wb-button [command]="cmd" displayStyle="Tertiary" />
        }
      </div>
    }

    @if (!$showBack() && $showClose()) {
      <button class="sp-page-close" (click)="close.emit()">
        <i class="fa-solid fa-x"></i>
      </button>
    }

  </div>
}

<div class="sp-page-body">
  <ng-content />
</div>

@if ($hasFooter()) {
  <div class="sp-page-footer">
    <div class="sp-page-footer-left">
      @for (cmd of $footerLeftCommands(); track cmd._id) {
        <!-- Footer-left is for destructive secondaries like Delete — skip Tab so users don't land on them by accident. -->
        <wb-button [command]="cmd" displayStyle="Tertiary" [tabindex]="-1" />
      }
    </div>
    <div class="sp-page-footer-right">
      <!-- Primary first in DOM so keyboard Tab reaches it before Cancel/secondary,
           then `flex-direction: row-reverse` keeps the visual order with primary on the right. -->
      @if ($footerSplitButton(); as splitBtn) {
        @if (splitBtn.commands?.length) {
          <wb-button-split [command]="splitBtn.command" [commands]="splitBtn.commands" displayStyle="Primary" />
        } @else {
          <wb-button [command]="splitBtn.command" displayStyle="Primary" />
        }
      }
      @for (cmd of $footerRightCommands(); track cmd._id) {
        <!-- Cancel-style secondaries — skip Tab; Esc handles dismissal. -->
        <wb-button [command]="cmd" displayStyle="Tertiary" [tabindex]="-1" />
      }
    </div>
  </div>
}
